<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16UbQ7Z/tc-custom/9781646569038.jpg?1723403694363" alt="This image is the cover for the book Charlie Blackbear"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Charlie Blackbear
      </h1>
      <p class="bookDescription body article font2">
        <p>Take an irresponsible, hard-drinking womanizer and dump him into the middle of a logging crew, and it’s a recipe for disaster.<br/><br/>Charlie Blackbear is already a near-legend in his little corner of the world. The size of his package has been the subject of whispers since he was a lad and his sexual conquests the stuff of legends.<br/><br/>When he wakes up drunk in a motel room with a man going down on him, he shrugs it off and goes right back to chasing women. Charlie accepts a job with a logging crew. But when he shares a room at the Boar’s Nest with his best friend, Daniel Warhorse, he fights a growing, unexpected, and unwelcome attraction to his childhood friend. Apparently Daniel feels the same way, and when they finally get together, the world turns on its axis for both of them.<br/><br/>Then handsome, sexy Aden Jones shows up to complicate things. Charlie never suspects the danger lurking at the edge of his complicated life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Wildyr
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c042944